/* 周瑜傳・第 2 章：赤壁・初戰（建安十三年，208）
 * 史實：《三國志·周瑜傳》「權遂遣瑜及程普等與備并力逆曹公，遇於赤壁。時曹公軍眾已有疾病，初一交戰，公軍敗退，引次江北。瑜等在南岸。」
 *       接著黃蓋獻火攻之計：「今寇眾我寡，難與持久。然觀操軍船艦，首尾相接，可燒而走也。」（之後的火船、烏林在孫吳傳第 12～14 章）
 * 流程：曹軍的船一波波從北岸划過來，要在南岸（赤壁）的三處灘頭登岸。周瑜守中間，程普守西邊的灘頭（「左右督」）。
 *       半渡而擊：船還在江上時射倒船頭（掌舵的人），整船就翻了；靠了岸，船上的兵就上岸搶灘（曹軍有疫病，比較弱）。
 *       岸上同時有 10 個以上的曹兵就失守。撐過四波，曹軍敗退、引次江北；黃蓋獻計。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, TROOPS } from '../kit.ts';

const LV = 11, SHORE_S = 3990, BEACHES = [3300, 4600, 5900], FROM_Y = 1750, LOST_AT = 10;
const WAVES = [[4600], [3300, 5900], [4600, 3300, 5900], [5900, 4600, 3300]], WAVE_GAP = 26;
const SICK = { spec: TROOPS.wei, name: '曹軍', hp: 420, maxHp: 420, atk: 22, ms: 215 };
const HELM = { spec: TROOPS.wei, name: '船頭', hp: 380, maxHp: 380, atk: 30, armor: 2 };
const landOk = (x, y) => y > SHORE_S - 140;

export default {
  id: 'zhouyu-2', map: 'chibi', hero: 'zhouyu',
  title: '第 2 章　赤壁・初戰', year: '建安十三年（208）',
  brief: {
    quote: [{ text: '時曹公軍眾已有疾病，初一交戰，公軍敗退，引次江北。', src: '《三國志·吳書·周瑜傳》' }],
    text: '孫權派周瑜、程普為左右督，各領萬人，和劉備一起逆擊曹操，在赤壁相遇。曹軍剛得了荊州的水軍，但營中已經有疾病。曹軍的船要搶渡南岸。',
    goals: ['守住南岸的三處灘頭', '船還在江上時射倒船頭，整船就翻', '撐到曹軍敗退'],
  },
  words: { ally: '吳兵', foe: '曹軍' },
  stars: [
    { text: '半渡而擊：翻掉 6 艘以上的船', ok: (m) => m.vars.sunk >= 6 },
    { text: '靠岸的船不超過 2 艘', ok: (m) => m.vars.landed <= 2 },
    { text: '程普沒有倒下', ok: (m) => !m.vars.cpDown },
  ],
  steps: [
    { // 0. 搶渡
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = BEACHES[1]; me.y = SHORE_S + 160;
        V.sunk = 0; V.landed = 0; V.wave = 0; V.waveT = 8; V.boats = []; V.ashore = [];
        V.cp = ally(w, 'chengpu', BEACHES[0], SHORE_S + 140, LV); V.cp.hold = [BEACHES[0], SHORE_S + 140];
        V.men = BEACHES.flatMap((x) => Array.from({ length: 3 }, (_, i) => { const u = m.recruit(x - 120 + i * 120, SHORE_S + 220, '吳兵'); u.home = [u.x, u.y]; return u; }));
        // 每處灘頭兩名弓手：射得到快靠岸的船
        V.bows = BEACHES.flatMap((x) => [-1, 1].map((s) => { const u = m.recruit(x + s * 70, SHORE_S + 110, '吳弓手'); Object.assign(u, { spec: SG.ARCHERS.wu, range: 380, atk: 20, home: [u.x, u.y] }); return u; }));
        BEACHES.forEach((x, i) => m.mark('b' + i, x, SHORE_S + 40, '灘頭', true));
        m.card('權遂遣瑜及程普等與備并力逆曹公，遇於赤壁。', '《周瑜傳》');
        m.line('周瑜', '曹軍要搶渡了。趁他們還在江上，打！');
        m.after(5, () => m.line('提示', '船頭（掌舵的人）一倒，整船就翻。船靠了岸，兵就上來搶灘：岸上同時有 10 個曹兵，灘頭就失守。'));
        m.obj('wave', `擋住曹軍搶渡（0/${WAVES.length} 波）`);
        m.obj('sunk', '翻船 0 艘');
      },
      tick(m, w, dt) {
        const V = m.vars;
        if (V.wave < WAVES.length && (V.waveT -= dt) <= 0) {
          const list = WAVES[V.wave++]; V.waveT = WAVE_GAP;
          list.forEach((bx, i) => m.after(i * 7, () => launch(m, w, bx))); // 一艘接一艘：來得及跑去下一處灘頭
          m.big(`曹軍第 ${V.wave} 波船隊！`);
        }
        m.get('wave').text = `擋住曹軍搶渡（${Math.min(V.wave, WAVES.length)}/${WAVES.length} 波）`;
        m.get('sunk').text = `翻船 ${V.sunk} 艘，靠岸 ${V.landed} 艘`;
        // 船頭倒了：整船翻
        for (const b of V.boats) if (!b.done && !b.u.alive) {
          b.done = true; V.sunk++;
          for (const c of b.crew) if (c.alive) { c.alive = false; c.deadT = w.t; }
          m.unboat(b); w.fx({ k: 'boom', x: b.x, y: b.y, r: 120, col: '#9ac0d8' });
          w.dmgEvents.push({ x: b.x, y: b.y - 60, text: '翻船！', team: 0, src: w.player.id });
        }
        for (const b of V.boats) if (!b.done) b.sp = b.y > SHORE_S - 600 ? 42 : 90; // 近岸水淺、要找地方靠：划得慢（半渡而擊的時機）
        // 卡在岸邊淺處划不動的船：直接搶灘
        for (const b of V.boats) if (!b.done && b.u.alive && !b.goal) {
          const p = SG.MAP.nearestFree(b.x, SHORE_S + 80);
          m.unboat(b); b.u.x = p[0]; b.u.y = p[1];
          b.crew.forEach((c, i) => { if (c.alive) { const q = SG.MAP.nearestFree(p[0] - 40 + i * 40, p[1] + 30); c.x = q[0]; c.y = q[1]; } });
          b.onLand(b);
        }
        const ashore = w.units.filter((u) => u.alive && u.team === 1 && !u.boat && u.y > SHORE_S - 80).length;
        V.ashoreN = ashore;
        if (ashore >= LOST_AT) { m.lose('灘頭失守'); return false; }
        const done = V.wave >= WAVES.length && !m.timers.length && V.boats.every((b) => b.done) && !w.units.some((u) => u.alive && u.team === 1 && !u.untargetable);
        return done;
      },
    },
    { // 1. 公軍敗退，引次江北
      enter(m, w) {
        m.done('wave'); m.done('sunk');
        BEACHES.forEach((x, i) => m.unmark('b' + i));
        m.card('初一交戰，公軍敗退，引次江北。瑜等在南岸。', '《周瑜傳》');
        const V = m.vars;
        V.hg = ally(w, 'huanggai', w.player.x + 160, w.player.y + 40, LV);
        m.after(5, () => m.line('黃蓋', '今寇眾我寡，難與持久。然觀操軍船艦，首尾相接，可燒而走也。'));
        m.after(10, () => m.card('乃取蒙衝鬥艦數十艘，實以薪草，膏油灌其中，裹以帷幕，上建牙旗，先書報曹公，欺以欲降。（接孫吳傳第 12 章「黃蓋火船」）', '《周瑜傳》'));
        m.after(15, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('周瑜陣亡'); return; }
    if (V.cp) { allyTick(w, V.cp, me, 560); if (!V.cp.alive) V.cpDown = true; }
    if (V.hg) allyTick(w, V.hg, me);
  },
};

// 一艘曹軍的船：從北岸划向灘頭 bx；船頭 + 2 個染疫的兵
function launch(m, w, bx) {
  const V = m.vars, x = bx + (SG.rand() - 0.5) * 500, y = FROM_Y + SG.rand() * 200;
  const helm = m.foe('bandit', x, y, Object.assign({}, HELM)), crew = Array.from({ length: 2 }, () => m.foe('huangjin', x, y, Object.assign({}, SICK)));
  for (const u of [helm, ...crew]) w.addBuff(u, { id: '疫', t: 9999, neg: true, ms: -0.12, atkP: -0.2 });
  const b = m.boat(helm, { x, y, crew, sp: 90, land: true, landOk, flag: '#3b5a99', col: '#4a3a28', onLand: (bb) => { bb.done = true; V.landed++; m.line('吳兵', '有船靠岸了！'); for (const u of [bb.u, ...bb.crew]) if (u.alive) u.home = [u.x, u.y + 200]; } });
  b.goal = [bx + (SG.rand() - 0.5) * 300, SHORE_S + 60];
  V.boats.push(b);
}
